import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'

export default function FormDialog(props) {
    const { title, submitText = "Submit", onSubmit, onCancel, children, ...otherProps } = props

    return (
        <Dialog
                PaperProps={{
                    component: 'form',
                    onSubmit,
                }}
                {...otherProps}
            >
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    {children}
                </DialogContent>
                <DialogActions>
                    <Button
                        type="submit"
                        color="primary"
                    >
                        {submitText}
                    </Button>
                    <Button
                        color="secondary"
                        autoFocus
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
    )
}
